import ManualDiscountInformation from './ManualDiscountInformation'

export default ManualDiscountInformation
